import { Autocomplete, FormControl, MenuItem, TextField, Typography } from '@mui/material';
import { filterHelper } from 'common/components/sharedCustomComponents/Common/helpers';
import { CustomPaperComponent, DISPLAYED_ROWS_COUNT } from 'common/components/sharedCustomComponents/CustomPaperComponent';
import { DEFAULT_TENANT } from 'common/constants/reports';
import { ApplicationSuite,AppSuiteTenant } from 'common/types/Entities';
import { useFetchTenants } from 'features/reports/hooks/useFetchTenants';

export function TenantSearchableDropDown(props: Readonly<{
        appSuite: ApplicationSuite | null,
        onChange: (event: unknown, value: AppSuiteTenant | null) => void,
		disabled: boolean,
        value?: AppSuiteTenant,
    }>) {
    const { appSuite, value, onChange, disabled } = props;

    const {
        singleTenant,
        tenants,
        processing
    } = useFetchTenants({ appSuite, onChange, disabled });

    const tenantDropDownOptions = singleTenant ?
        [DEFAULT_TENANT, singleTenant]
        : [DEFAULT_TENANT, ...tenants];

    return (
        <FormControl>
            <Autocomplete
                handleHomeEndKeys={false}
                disabled={disabled}
                value={value}
                onChange={onChange}
                disableClearable
                loading={processing}
                options={tenantDropDownOptions}
                filterOptions={filterHelper}
                getOptionLabel={tenantProp => tenantProp.name}
                isOptionEqualToValue={(opt, val) => opt.id === val.id}
                renderInput={(params) => <TextField {...params} label="Tenant" />}
                PaperComponent={CustomPaperComponent}
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                renderOption={({ key: _, ...params }, tenantProp) => {
                    if (params.id && Number(params.id.split('-').pop()) > DISPLAYED_ROWS_COUNT) {
                        return null;
                    }
                    return (
                        <MenuItem
                            key={tenantProp.id}
                            {...params}
                            value={tenantProp.id}
                            style={tenantProp.id ? { display: 'block' } : { display: 'none' } }
                        >
                            <Typography>
                                {tenantProp.name}
                            </Typography>
                        </MenuItem>
                    );
                }}
            />
        </FormControl>
    );
}
